import { render, staticRenderFns } from "./FilterConfigSection.vue?vue&type=template&id=5d87034d&scoped=true&"
import script from "./FilterConfigSection.vue?vue&type=script&lang=js&"
export * from "./FilterConfigSection.vue?vue&type=script&lang=js&"
import style0 from "./FilterConfigSection.vue?vue&type=style&index=0&id=5d87034d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d87034d",
  null
  
)

export default component.exports